export const protocolDesignerSubTabParam = 'protocolDesignerSubTab';
